// extracted by mini-css-extract-plugin
export default {"tipContainer":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelCheckout-Components-TableTip-css-module__tipContainer--TvvBR"};